import React, { FunctionComponent } from "react";
import styles from "./Announcements.module.scss";
import AnnouncementsContent from "./AnnouncementsContent.model";

import Announcement from "./components/Announcement/Announcement";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";

const Announcements: FunctionComponent<AnnouncementsContent> = (props) => {
    const processedHeadline = getProcessedRichtext(formatDynamicTextColor(props.content.headline));
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Intro */}
                {props.content.headline || processedBodyText ?
                    <div className={styles.intro}>
                        {/* Headline */}
                        <DynamicHeading className={styles.headline} headlineSize={props.content.headlineSize} headlineWeight={props.content.headlineWeight} innerHtml={processedHeadline}></DynamicHeading>

                        {/* Body Text */}
                        {processedBodyText ? <div className={styles.text} dangerouslySetInnerHTML={processedBodyText}></div> : null}
                    </div> : null}

                {/* Press Releases */}
                {props.content.announcements && props.content.announcements.length > 0 ?
                    <div className={styles.grid}>
                        {props.content.announcements.map(item => {
                            return (
                                <Announcement key={item.contentUdi} {...item} />
                            );
                        })}
                    </div> : null}
            </div>
        </section>
    );
};

export default Announcements;